import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["planType", "clubField", "userField", "clubSelect", "userSelect"]

  connect() {
    this.updateFields()
  }

  updateFields() {
    const planType = this.planTypeTarget.value

    // Masquer tous les champs et réinitialiser Tom Select
    this.hideField(this.clubFieldTarget, this.clubSelectTarget)
    this.hideField(this.userFieldTarget, this.userSelectTarget)

    // Afficher le bon champ selon le plan_type
    if (planType === 'player_premium' || planType === 'jap_premium') {
      this.showField(this.userFieldTarget)
      this.updateUserUrl(planType)
    } else if (planType === 'club_standard' || planType === 'club_premium' || planType === 'club_trial') {
      this.showField(this.clubFieldTarget)
    } else if (planType === 'sponsor_free') {
      this.showField(this.userFieldTarget)
      this.updateUserUrlForSponsor()
    }
  }

  hideField(fieldTarget, selectTarget) {
    fieldTarget.classList.add('hidden')

    // Détruire l'instance Tom Select si elle existe
    if (selectTarget.tomselect) {
      selectTarget.tomselect.clear()
      selectTarget.tomselect.clearOptions()
    }
  }

  showField(fieldTarget) {
    fieldTarget.classList.remove('hidden')
  }

  updateUserUrl(planType) {
    const role = planType === 'player_premium' ? 'joueur' : 'juge_arbitre'

    // Mettre à jour l'URL de recherche AJAX pour filtrer par rôle
    if (this.userSelectTarget.dataset.tomSelectAjaxUrlValue) {
      this.userSelectTarget.dataset.tomSelectAjaxUrlValue = `/admin/users.json?role=${role}`
    }

    // Mettre à jour le placeholder
    const placeholderText = role === 'joueur'
      ? 'Rechercher un joueur...'
      : 'Rechercher un JAP...'

    if (this.userSelectTarget.dataset.tomSelectAjaxPlaceholderValue) {
      this.userSelectTarget.dataset.tomSelectAjaxPlaceholderValue = placeholderText
    }

    // Réinitialiser Tom Select avec la nouvelle URL
    if (this.userSelectTarget.tomselect) {
      this.userSelectTarget.tomselect.settings.placeholder = placeholderText
      this.userSelectTarget.tomselect.clear()
      this.userSelectTarget.tomselect.clearOptions()

      // Mettre à jour la fonction load pour utiliser la nouvelle URL
      const originalLoad = this.userSelectTarget.tomselect.settings.load
      this.userSelectTarget.tomselect.settings.load = (query, callback) => {
        if (!query || query.length < 2) {
          callback()
          return
        }

        const url = `/admin/users.json?role=${role}&q=${encodeURIComponent(query)}`

        fetch(url, {
          headers: {
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
          .then(response => {
            if (!response.ok) throw new Error(`HTTP ${response.status}`)
            return response.json()
          })
          .then(data => {
            // Les données sont déjà au format Tom Select: { value, text }
            callback(data)
          })
          .catch(error => {
            console.error('Erreur AJAX:', error)
            callback()
          })
      }
    }
  }

  updateUserUrlForSponsor() {
    const role = 'sponsor'

    // Mettre à jour l'URL de recherche AJAX pour filtrer par rôle
    if (this.userSelectTarget.dataset.tomSelectAjaxUrlValue) {
      this.userSelectTarget.dataset.tomSelectAjaxUrlValue = `/admin/users.json?role=${role}`
    }

    // Mettre à jour le placeholder
    const placeholderText = 'Rechercher un sponsor...'

    if (this.userSelectTarget.dataset.tomSelectAjaxPlaceholderValue) {
      this.userSelectTarget.dataset.tomSelectAjaxPlaceholderValue = placeholderText
    }

    // Réinitialiser Tom Select avec la nouvelle URL
    if (this.userSelectTarget.tomselect) {
      this.userSelectTarget.tomselect.settings.placeholder = placeholderText
      this.userSelectTarget.tomselect.clear()
      this.userSelectTarget.tomselect.clearOptions()

      // Mettre à jour la fonction load pour utiliser la nouvelle URL
      this.userSelectTarget.tomselect.settings.load = (query, callback) => {
        if (!query || query.length < 2) {
          callback()
          return
        }

        const url = `/admin/users.json?role=${role}&q=${encodeURIComponent(query)}`

        fetch(url, {
          headers: {
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
          .then(response => {
            if (!response.ok) throw new Error(`HTTP ${response.status}`)
            return response.json()
          })
          .then(data => {
            callback(data)
          })
          .catch(error => {
            console.error('Erreur AJAX:', error)
            callback()
          })
      }
    }
  }
}
